import { render, staticRenderFns } from "./SgaCompleto.vue?vue&type=template&id=d1b74182"
import script from "./SgaCompleto.vue?vue&type=script&lang=js"
export * from "./SgaCompleto.vue?vue&type=script&lang=js"
import style0 from "./SgaCompleto.vue?vue&type=style&index=0&id=d1b74182&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports